module.exports = __webpack_public_path__ + "static/media/sponsors.400bb62d.png";